import React, { PureComponent } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import classnames from 'classnames';

class Spinner extends PureComponent {
  render() {
    const {
      global,
      small,
      className,
      color
    } = this.props;
    const classNames = classnames(['spinner-container', className, {
      'spinner-container--small': small,
      global
    }]);
    const spinnerClassNames = classnames(['spinner', 'a-loading', {
      'a-default': !color,
      'a-primary': color
    }]);
    return /*#__PURE__*/React.createElement("div", {
      className: classNames
    }, /*#__PURE__*/React.createElement("div", {
      className: spinnerClassNames
    }));
  }
}
Spinner.defaultProps = {
  global: false,
  small: false,
  color: false
};
const stringifiedSpinner = renderToStaticMarkup(/*#__PURE__*/React.createElement(Spinner, null));

export { Spinner as default, stringifiedSpinner };
